import NotFound from "../pages/NotFound";
import { LoginPage } from "../pages/login";
import Home from "../pages/home/page";
import ChatPage from "../pages/chat/page";
import SearchPage from "../pages/search/page";
import SettingsPage from "../pages/settings/page";
import PersonalSettingsPage from "../pages/personal-settings/PersonalSettingsPage";
import UsersPage from "../pages/users/page";
import AnalyticsPage from "../pages/analytics/page";
import IntegrationsPage from "../pages/integrations/page";
import WidgetGeneratorPage from "../pages/widget-generator/page";
import EmailService from "../pages/email-service/EmailService";
import DocsSitePage from "../pages/docs-site/page";
import TicketingPage from "../pages/tickets/TicketingPage";
import ProtectedLayout from "./ProtectedLayout";
import AgentInvitePage from "../pages/invite/AgentInvitePage";
import ForgotPasswordPage from "../pages/forgot-password/ForgotPasswordPage";
import LoginGoogleCompletePage from "../pages/login/LoginGoogleCompletePage";

const routes = [
  { path: "/login", element: <LoginPage /> },
  { path: "/login/google/complete", element: <LoginGoogleCompletePage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  // Public — no auth; accessible outside ProtectedLayout
  { path: "/t/:tenantId/invite/agent", element: <AgentInvitePage /> },
  {
    element: <ProtectedLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/chat", element: <ChatPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/bot-chats", element: <ChatPage /> },
      { path: "/settings", element: <SettingsPage /> },
      { path: "/personal-settings", element: <PersonalSettingsPage /> },
      { path: "/users", element: <UsersPage /> },
      { path: "/analytics", element: <AnalyticsPage /> },
      { path: "/tickets", element: <TicketingPage /> },
      { path: "/integrations", element: <IntegrationsPage /> },
      { path: "/widget-generator", element: <WidgetGeneratorPage /> },
      { path: "/email-service", element: <EmailService /> },
      { path: "/docs-site", element: <DocsSitePage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;
